import { render, staticRenderFns } from "./studentprofile.vue?vue&type=template&id=500a85a4&"
import script from "./studentprofile.vue?vue&type=script&lang=js&"
export * from "./studentprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports